/*
 * Which colour to show when the Style (Classic / Diamond ...) changes, or when a link names a colour the chosen Style
 * does not sell. Styles sell different colour lists, and Shrine's own repair walks the combined Color list by
 * position (Classic "Black with Red Stitching" -> Diamond "Beige"), so a shopper looking at black/red seats would be
 * shown beige ones. Rule, generic over colour names (no per-product list):
 *   1. the same colour when the Style sells it ('&', 'and' and punctuation ignored: black-red = Black & Red);
 *   2. else the sold colour with the best score: +2 per shared accent word (the name's words without black / with /
 *      stitching / and; tan and ivory count as beige), +1 when both names contain "black" or neither does; ties go
 *      to the first in option order;
 *   3. no shared accent word at all -> Black when sold, else the Style's first colour.
 * Loaded `defer` by snippets/seatfit-style-state.liquid (products with a Style option only), before
 * seatfit-style-state.js (Style pill switch) and the vehicle steps (colour links), which both use it.
 */
(function () {
  'use strict';
  if (window.SeatFitStyleColor) return;
  var FILLER = { black: 1, with: 1, stitching: 1, and: 1 };
  var SAME_AS = { tan: 'beige', ivory: 'beige' };

  function words(name) {
    return String(name == null ? '' : name).toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  }
  // One spelling for a colour name, a page slug and a hand-typed link: "Black & Red" = black-and-red = black-red.
  function key(name) { return words(name).filter(function (w) { return w !== 'and'; }).join('-'); }
  function accents(name) {
    var out = [];
    words(name).forEach(function (w) {
      w = SAME_AS[w] || w;
      if (!FILLER[w] && out.indexOf(w) < 0) out.push(w);
    });
    return out;
  }
  function hasBlack(name) { return words(name).indexOf('black') >= 0; }
  function find(list, name) {
    var k = key(name);
    for (var i = 0; i < list.length; i++) if (key(list[i]) === k) return list[i];
    return '';
  }

  // want: a colour name or slug; sold: the colour names the target Style sells, in option order. '' = none sold.
  function match(want, sold) {
    sold = (sold || []).filter(Boolean);
    if (!sold.length) return '';
    var same = find(sold, want);
    if (same) return same;
    var mine = accents(want);
    var black = hasBlack(want);
    var best = '';
    var top = -1;
    sold.forEach(function (c) {
      var shared = accents(c).filter(function (w) { return mine.indexOf(w) >= 0; }).length;
      var score = 2 * shared + (hasBlack(c) === black ? 1 : 0);
      if (score > top) { top = score; best = c; }
    });
    // Without a shared accent word the best score is 1: nothing alike, so the plain default.
    return top > 1 ? best : find(sold, 'Black') || sold[0];
  }

  // Colours (from `colors`, option order) of the variants whose Style option (1-based stylePos) is `style`. The
  // Color position is the option whose value is a colour on every variant, so option names never matter.
  function sold(variants, stylePos, style, colors) {
    var list = (variants || []).filter(function (v) { return v && v.options; });
    if (!list.length) return [];
    var si = stylePos - 1;
    var ci = -1;
    for (var i = 0; i < list[0].options.length && ci < 0; i++) {
      if (i !== si && list.every(function (v) { return colors.indexOf(v.options[i]) >= 0; })) ci = i;
    }
    if (ci < 0) return [];
    var mine = list.filter(function (v) { return v.options[si] === style; });
    return colors.filter(function (c) { return mine.some(function (v) { return v.options[ci] === c; }); });
  }

  // The variant list Shrine prints inside <variant-selects> (parsed once per script element).
  function variantsOf(vs) {
    var tag = vs && vs.querySelector('script[type="application/json"]');
    if (!tag) return [];
    if (!tag.sfVariants) {
      try { tag.sfVariants = JSON.parse(tag.textContent); } catch (e) { tag.sfVariants = []; }
    }
    return Array.isArray(tag.sfVariants) ? tag.sfVariants : [];
  }

  function colorsOf(vs, colorName) {
    var name = colorName || 'Color';
    return Array.prototype.filter.call(vs.querySelectorAll('input[type="radio"]'), function (r) {
      return r.name.indexOf(name) === 0;
    }).map(function (r) { return r.value; });
  }

  function styleInfo() {
    var S = window.SeatFitStyle;
    return S && S.position ? S : null;
  }

  // Colour to choose in `style` for `want` ('' = not a colour of this product: the caller keeps its own handling).
  function colorFor(vs, style, want, colorName) {
    var S = styleInfo();
    if (!S || !vs || !style) return '';
    var colors = colorsOf(vs, colorName);
    if (!find(colors, want)) return '';
    return match(want, sold(variantsOf(vs), S.position, style, colors));
  }

  // A colour link without ?style=: the first Style (option order) that sells the colour, when `current` does not.
  function styleFor(vs, current, want, colorName) {
    var S = styleInfo();
    if (!S || !vs || !want) return '';
    var colors = colorsOf(vs, colorName);
    var variants = variantsOf(vs);
    var sells = function (style) { return !!find(sold(variants, S.position, style, colors), want); };
    if (!current || sells(current)) return '';
    for (var i = 0; i < S.styles.length; i++) if (sells(S.styles[i].v)) return S.styles[i].v;
    return '';
  }

  window.SeatFitStyleColor = { match: match, sold: sold, colorFor: colorFor, styleFor: styleFor };
})();
